import React from 'react';

export class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { err?: Error }
> {
  constructor(props: any) { 
    super(props); 
    this.state = { err: undefined }; 
  }
  
  static getDerivedStateFromError(err: Error) { 
    return { err }; 
  }
  
  componentDidCatch(err: Error, info: any) { 
    console.error('[AppErrorBoundary]', err, info); 
  }
  
  render() {
    if (this.state.err) {
      return (
        <div style={{padding: 24, fontFamily: 'system-ui'}}>
          <h2>Something went wrong</h2>
          <p>We hit an unexpected error while loading the app.</p>
          <pre style={{whiteSpace: 'pre-wrap', background: '#fafafa', padding: 12, border: '1px solid #eee'}}>
            {String(this.state.err?.stack || this.state.err?.message)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
